export default __webpack_public_path__ + "static/media/Helm of the Steel Behemoth.02b6c2c4.jpg";